import { render, staticRenderFns } from "./_submittal-information.vue?vue&type=template&id=5b2f1aa9"
import script from "./_submittal-information.vue?vue&type=script&lang=js"
export * from "./_submittal-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports